export default __webpack_public_path__ + "static/media/agrivore_icon.88e28497.png";